// @ts-nocheck
/**
 * StatusStripCell — reusable render of the colored status bars used
 * on the Dashboard. Each color represents an event condition (Fully Booked,
 * SOW in progress, edited by client, HR/Payroll unapproved). Each bar has a
 * tooltip with its description.
 *
 * Props:
 *  - row: the event object
 *  - text: text displayed next to the bars (e.g. "Ongoing", "Past")
 *         Default: row.eventStatus
 *  - width: total width of the strip (default "100px")
 *  - height: height (default "28px")
 *
 * The colors and reasons come from getRowStrips in utils/methods/eventUtils.ts.
 */
import { Box, Tooltip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getRowStrips } from "../../utils/methods/eventUtils";
import { isUserRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";

const StatusStripCell = ({
  row,
  text,
  width = "100px",
  height = "28px",
  showText = true,
  adminOnly = true,
}) => {
  const auth = useSelector((s) => s.auth);
  if (
    adminOnly &&
    !isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)
  ) {
    return showText ? (
      <Typography>{text ?? row?.eventStatus ?? "N/A"}</Typography>
    ) : null;
  }

  const strips = getRowStrips(row);
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
      {strips.length > 0 ? (
        <Box
          sx={{
            flexShrink: 0,
            display: "flex",
            width,
            height,
            borderRadius: "4px",
            overflow: "hidden",
          }}
        >
          {strips.map((s, i) => (
            <Tooltip key={i} title={s.reason} arrow placement="top">
              <Box
                sx={{
                  flex: 1,
                  height: "100%",
                  backgroundColor: s.color,
                  cursor: "default",
                }}
              />
            </Tooltip>
          ))}
        </Box>
      ) : null}
      {showText ? (
        <Typography>{text ?? row?.eventStatus ?? "N/A"}</Typography>
      ) : null}
    </Box>
  );
};

export default StatusStripCell;
